import { ImageElement } from '@/types';
import React, { memo } from 'react';
import styles from './ImageComponent.module.scss';

const ImageComponent: React.FC<ImageElement & { title?: string }> = ({
  img,
  desc,
  width = 50,
  height = 50,
  title,
}: ImageElement & { title?: string }) => (
  <img
    className={styles.image}
    src={img}
    alt={desc}
    width={width}
    height={height}
    title={title}
  />
);

export default memo(ImageComponent);
